import { render } from "./ReturnedItemDamage.vue?vue&type=template&id=5baa7d85"
import script from "./ReturnedItemDamage.vue?vue&type=script&lang=js"
export * from "./ReturnedItemDamage.vue?vue&type=script&lang=js"

import "./ReturnedItemDamage.vue?vue&type=style&index=0&id=5baa7d85&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__